export default {
    "data": {
        "h5": {
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20210818/1629276158493.png",
                "https://s21.lgstatic.com/growth/activity/20210818/1629276200437.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628230368678.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628230386759.png",
                "https://s21.lgstatic.com/growth/activity/20210818/1629276243040.png"
            ],
            "btnImg": {
                "receive": "https://s21.lgstatic.com/growth/activity/20210806/1628233539046.png",
                "btn1": "https://s21.lgstatic.com/growth/activity/20210806/1628235605303.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20210806/1628241867141.png",
                "icon": "https://s21.lgstatic.com/growth/activity/20210806/1628237182554.png",
            },
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210806/1628234413150.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628234464894.png"
            ],
            "imgList2": [
                "https://s20.lgstatic.com/growth/activity/20210806/1628235788852.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628235817556.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628235833627.png",
                // "https://s20.lgstatic.com/growth/activity/20210806/1628235850333.png",
                "https://s21.lgstatic.com/growth/activity/20210806/1628235858316.png"
            ],
            "swiperList": [
                "https://s20.lgstatic.com/growth/activity/20210806/1628234556456.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628234563698.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628234571187.png",
                "https://s20.lgstatic.com/growth/activity/20210806/1628234578230.png"
            ]

        },
        "pc": {
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20210825/1629871999897.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629872019117.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629872031902.png",
                "https://s21.lgstatic.com/growth/activity/20210825/1629872042489.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629872049597.png"
            ],
            "imgList1": [
                "https://s20.lgstatic.com/growth/activity/20210825/1629873416019.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629873424214.png"
            ],
            "imgList2": [
                "https://s20.lgstatic.com/growth/activity/20210825/1629875206555.png",
                // "https://s20.lgstatic.com/growth/activity/20210825/1629875216755.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629875223818.png"
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210825/1629872260641.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629872268614.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629872276613.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629872283506.png"
            ],
            "btnList": [
                "https://s20.lgstatic.com/growth/activity/20210825/1629874501083.png",
                "https://s21.lgstatic.com/growth/activity/20210825/1629873027377.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629874723255.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629874903336.png",
                "https://s20.lgstatic.com/growth/activity/20210825/1629875179950.png"
            ]

        },
        "stageList": [
            {
                "stage": "先导课",
                "title": "能力认知",
                "phaseTargetList": [
                    "介绍求职的能力标准和岗位要求",
                    "分析力行业现状及课程模块安排"
                ],
                "skillsList": [
                    "能力模型及UI设计师能力标准",
                    "岗位需求分析，对应中小企业及大厂需求",
                    "2021年UI设计趋势",
                    "案例实战：能力指数生成",
                ],
                "details": [
                ]
            }, {
                "stage": "第一阶段",
                "title": "UI设计基础",
                "phaseTargetList": [
                    "学习金刚区图标、tab图标设计方法及图标制作过程，包括了线性和面性图标的制作",
                    "学习优秀图标的标准及图形创意方法，通过案例拆解设计思路",
                    "学习基础规范，了解大厂UED文档库的建立"
                ],
                "skillsList": [
                    "图标制作",
                    "创意方法",
                    "设计规范"
                ],
                "details": [
                    {
                        "t": "一、图标制作",
                        "desc": [
                            "图标概述及发展30min（标识作用；拟物化、扁平化、微质感、设计风格循环）",
                            "应用图标的类型及作用30min（入口、tab、通用图标；线形、面形、结合）",
                            "图标绘制方法及流程20min（设计师图标绘制误区；正确绘制方法）",
                            "功能图标设计规范20min（图标设计规范，图示）",
                            "案例实战：20min功能图绘制（线性/面性）"
                        ]
                    }, {
                        "t": "二、创意方法",
                        "desc": [
                            "图标设计的美观标准（识别性、流行趋势、品牌感）",
                            "图标创意方法（情绪板创意法）",
                            "案例实战：创意延展图形绘制"
                        ]
                    }, {
                        "t": "三、设计规范",
                        "desc": [
                            "建立设计规范的目的（设计团队、开发协作）",
                            "移动端设计原则及尺寸、iPhoneX的适配方案",
                            "设计布局及适用场景（响应式、自适应）",
                            "组建化设计规范的建立（统一性、合作效率）",
                            "案例实战：Sketch组建库的建立及运用，标准页面的制作"
                        ]
                    }
                ]
            }, {
                "stage": "第二阶段",
                "title": "强化执行力",
                "phaseTargetList": [
                    "学习设计全流程，包括需求分析、原型评审、视觉认知、产品研究。",
                    "学习色彩感知、色彩情绪、色彩平衡在界面中的运用。",
                    "学习设计原理、布局原理、格式塔心理学等构图方法。",
                    "对常见的信息流布局进行案例分析，介绍视线引导的设计方法。",
                    "对教育类的产品进行案例分析，对K12相关界面案例进行实操制作。",
                    "对电商详情页面进行案例分析，加强对产品详情页面的设计能力。"
                ],
                "skillsList": [
                    "设计流程",
                    "界面配色",
                    "设计原理",
                    "信息流呈现",
                    "教育类界面",
                    "详情转化页"
                ],
                "details": [
                    {
                        "t": "一、设计流程",
                        "desc": [
                            "概述项目0-1的设计流程",
                            "UI提升环节的拆解分析",
                            "案例实战：Sketch框架图及高保真设计",
                        ]
                    }, {
                        "t": "二、界面配色",
                        "desc": [
                            "色彩基础知识",
                            "色彩在界面中的运用技巧",
                            "界面配色方法，主色、点缀色的定义",
                            "案例实战：运用合理配色制作页面"
                        ]
                    }, {
                        "t": "三、设计原理",
                        "desc": [
                            "概述项目0-1的设计流程",
                            "UI提升环节的拆解分析",
                            "案例实战：社交页面制作",
                        ]
                    }, {
                        "t": "四、信息流呈现",
                        "desc": [
                            "信息流页面介绍及案例分析",
                            "案例实战：信息页面制作"
                        ]
                    }, {
                        "t": "五、教育类界面",
                        "desc": [
                            "教育类产品设计分析",
                            "案例实战：教育类产品页面制作"
                        ]
                    }, {
                        "t": "六、详情转化页",
                        "desc": [
                            "详情页设计分析",
                            "案例实战：详情页面页面制作"
                        ]
                    }
                ]
            }, {
                "stage": "第三阶段",
                "title": "产品分析力",
                "phaseTargetList": [
                    "产品前期的调研流程、挖掘需求、用户调研、用户画像",
                    "竞品的分析步骤及分析方法",
                    "行为地图分析、故事版的使用方法",
                    "如何对页面架构逻辑的梳理及功能模块的布局的处理方法",
                    "拿到需求后，如何快速了解需求，对需求信息的走差方法",
                    "数据指标用户行为指标、业务数据指标、留存指标等"
                ],
                "skillsList": [
                    "用研及画像",
                    "竞品分析",
                    "行为分析",
                    "需求探索",
                    "需求走查",
                    "设计增长"
                ],
                "details": [
                    {
                        "t": "一、用研及画像",
                        "desc": [
                            "用户画像（画像是什么、画像价值、画像构建）",
                            "用户研究部（用研概念、调研形式、结果呈现）",
                            "案例实战：探索并输出闲鱼APP女性用户画像地图"
                        ]
                    }, {
                        "t": "二、竞品分析",
                        "desc": [
                            "竞品分析是什么、竞品分析语言、具体操作分析方法",
                            "前期准备、收集资料与目标确立、方法与模型、注意事项",
                            "案例实战：对百度搜索APP核心竞品展开综合分析"
                        ]
                    }, {
                        "t": "三、行为分析",
                        "desc": [
                            "什么是用户行为、用户行为的的完整链路",
                            "常见的分析方法与模型、核心注意事项与分析三要素",
                            "案例实战：对淘宝商品详情页加车行为进行分析"
                        ]
                    }, {
                        "t": "四、需求探索",
                        "desc": [
                            "需求是什么、需求类型介绍、理论在设计中的运用",
                            "需求获取方式、记录与筛选、ICE排序法则",
                            "案例实战：对任意搜索功能搜索联想页内容提效展开需求插拆解"
                        ]
                    }, {
                        "t": "五、需求走查",
                        "desc": [
                            "全局思考方式、反馈中提炼、明确优先级",
                            "走查的维度、走查的输出形式"
                        ]
                    }, {
                        "t": "六、设计增长",
                        "desc": [
                            "设计价值是什么、角色定位、思维方式建设",
                            "设计赋能的大概念、复盘的价值与总结的方式"
                        ]
                    }
                ]
            }, {
                "stage": "第四阶段",
                "title": "丰富表现力",
                "phaseTargetList": [
                    "介绍基本规范，通过案例进行演示布局层级罗列、组件的制定",
                    "介绍网页设计及小程序的设计规范，介绍了小程序与app的区别",
                    "介绍卡通IP制作流程及案例实操",
                    "介绍APP品牌元素的运用，案例演示表情动作延展制作",
                    "介绍宣传图、Banner制作方法，案例分析提高点击率的方法",
                    "介绍专题页面设计流程及思路，演示了H5设计的过程"
                ],
                "skillsList": [
                    "B端界面设计",
                    "网页/小程序设计",
                    "IP形象运用",
                    "元素延展",
                    "运营设计",
                    "H5活动"
                ],
                "details": [
                    {
                        "t": "一、B端界面设计",
                        "desc": [
                            "B端设计的趋势及原则",
                            "表格、弹窗、导航等组件的设计规范",
                            "案例实战：数据可视化设计"
                        ]
                    }, {
                        "t": "二、网页/小程序设计",
                        "desc": [
                            "网页的设计规范及适配",
                            "小程序设计规范及机制",
                            "案例实战：微信小程序设计"
                        ]
                    }, {
                        "t": "三、IP形象运用",
                        "desc": [
                            "IP形象设计思路",
                            "IP形象的额绘制技巧",
                            "案例实战：IP形象的制作"
                        ]
                    }, {
                        "t": "四、元素延展",
                        "desc": [
                            "IP形象在界面中的延展",
                            "品牌记忆元素的提炼及运用",
                            "案例实战：形象延展"
                        ]
                    }, {
                        "t": "五、运营设计",
                        "desc": [
                            "视觉表现的趋势及运用",
                            "如何通过设计引导点击",
                            "案例实战：banner设计操作及规范"
                        ]
                    }, {
                        "t": "六、H5活动",
                        "desc": [
                            "引流落地页的设计思路",
                            "活动视觉的设计方法",
                            "案例实战：H5活动专题页设计"
                        ]
                    }
                ]
            }, {
                "stage": "第五阶段",
                "title": "交互动效制作",
                "phaseTargetList": [
                    "介绍多种交互设计原则，如菲茨定律、席克定律、神奇数字7±2、接近法则等",
                    "介绍基本动画的原理，介绍metiral design动效设计的规律",
                    "介绍基本动画的原理，通过案例制作还原物理动画原理",
                    "介绍人物MG动画的制作方法，通过案例演示制作过程",
                    "介绍C端直播产品的礼物动画，通过案例进行演示制作",
                    "介绍Principle动效软件的使用，通过案例制作演示可交互性界面"
                ],
                "skillsList": [
                    "交互原则",
                    "动效原理",
                    "加载动画",
                    "MG动画",
                    "礼物特效",
                    "交互性动效"
                ],
                "details": [
                    {
                        "t": "一、交互原则",
                        "desc": [
                            "人机交互的设计法则",
                            "设计心理学的运用"
                        ]
                    }, {
                        "t": "二、动效原理",
                        "desc": [
                            "动效设计的应用",
                            "metiral design动效原则",
                            "案例实战：页面转场动效"
                        ]
                    }, {
                        "t": "三、加载动画",
                        "desc": [
                            "加载动画的形式：系统加载、占位符加载、定制化加载",
                            "loading设计创意方法",
                            "案例实战：打车业务loading"
                        ]
                    }, {
                        "t": "四、MG动画",
                        "desc": [
                            "MG动画案例讲解",
                            "动画关键动作分解",
                            "案例实战：智能机器人动画"
                        ]
                    }, {
                        "t": "五、礼物特效",
                        "desc": [
                            "礼物特效分析、解锁等级动效",
                            "案例实际操作",
                            "案例实战：开箱动画"
                        ]
                    }, {
                        "t": "六、交互性动效",
                        "desc": [
                            "软件基础教学：点击、长按、滑动、定位等",
                            "分析动效案例的实现方式",
                            "案例实战：卡片放大滑动动效"
                        ]
                    },
                ]
            }, {
                "stage": "第六阶段",
                "title": "就业辅导",
                "phaseTargetList": [
                    "介绍常见的面试问题和沟通方法",
                    "针对学员作品进行1v1辅导，给出针对性的修改意见，对作品集的质量进行反复优化"
                ],
                "skillsList": [
                    "作品集攻略",
                    "面试技巧",
                    "1v1作品集辅导"
                ],
                "details": [
                ]
            },
        ]
    }
}